// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4":"a8f5d343d34c7a3f","285":"d78e857faa7c03de","421":"3c6473c61f2a7211"}[chunkId] + ".js";
};